import { css } from "@emotion/react";

type ListProps<T> = {
  /** Optional id to assign to ul element */
  id?: string;
  /** List Item renderer */
  itemRenderer: (item: T, index: number) => React.ReactNode;
  /** Loaded items */
  items: Array<T>;
  /** Gap Spacing for list items */
  gap?: number;
  /** Function that takes (item, index) and returns the row key */
  getKey?: (item: T, index: number) => string | number;
};

const getKeyDefault = (_item: unknown, i: number): number => i;

const rootStyle = css`
  list-style-type: none;
  margin: 0px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  padding: 0px;
  padding-inline-start: 0px;
  -webkit-margin-after: 0px;
  -webkit-margin-before: 0px;
  -webkit-padding-start: 0px;
`;

const rootWithGap = (gap: number) => css`
  display: grid;
  grid-gap: ${gap}px;
`;

/**
 * Shows a list of items
 */
function List<T>({ getKey = getKeyDefault, ...props }: ListProps<T>) {
  const listItems = props.items.map((item, i) => (
    <li key={getKey(item, i)}>{props.itemRenderer(item, i)}</li>
  ));

  return (
    <ul css={[rootStyle, props.gap && rootWithGap(props.gap)]} id={props.id}>
      {listItems}
    </ul>
  );
}

export default List;
